import { render, staticRenderFns } from "./ExamHistoryDetail.vue?vue&type=template&id=be431bb4&scoped=true"
import script from "./ExamHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ExamHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamHistoryDetail.vue?vue&type=style&index=0&id=be431bb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be431bb4",
  null
  
)

export default component.exports